import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { AnotaToastModule } from '@githubanotaai/design-system';
import { environment } from './environments/environment';

if (environment.envName !== 'local') {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    importProvidersFrom(
      AnotaToastModule,
    ),
  ],
}).catch(err => console.error(err));
